import { render } from "./add-edit-signatory-modal.html?vue&type=template&id=bf6677d6&scoped=true&ts=true&external"
import script from "./add-edit-signatory-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-signatory-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-signatory-modal.scss?vue&type=style&index=0&id=bf6677d6&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6677d6"]])

export default __exports__